
<script>
	import formBase from '@_system/components/base/form.vue'
	export default {
		extends: formBase,
		name: 'goodsgroupForm',
		props: {

		},
		data() {
			return {
				exportData: [],
				loading: false
			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {


		},
		components: {

		}
	}
</script>
